// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3WaNt","colMaxWidth":"Table_colMaxWidth__12-UP"};